import { AddImageIcon } from 'icons';
import { ColumnButton } from 'lib/components/ColumnButton';
import { Modal } from 'lib/components/Modal';
import { MediaModel } from 'lib/model/objects/mediaModel';
import { Media } from 'lib/types';
import { Ad } from 'lib/types/ad';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';
import { useState } from 'react';
import { useMediaLibrary } from 'routes/settings/publisher/generalOrderSettings/ClipArtSettings/ClipArtLibrary/clipArtHelpers';
import MediaGrid from 'routes/settings/publisher/generalOrderSettings/ClipArtSettings/ClipArtLibrary/MediaGrid';
import { useBooleanFlag } from 'utils/flags';

type BackgroundImageButtonProps = {
  currentBackgroundImage?: Ad['backgroundImage'];
  product: Media['folder'];
  organizationId: string;
  onChange: (media: MediaModel | null) => void;
};

function BackgroundImageButton({
  currentBackgroundImage,
  product,
  organizationId,
  onChange
}: BackgroundImageButtonProps) {
  const [showBackgroundImageModal, setShowBackgroundImageModal] =
    useState(false);

  const enableBackgroundImageButton = useBooleanFlag(
    LaunchDarklyFlags.ENABLE_BACKGROUND_IMAGES_IN_ORDERS
  );

  // Pass in newspaperOrder organization ID
  // Pass in product
  const { value: mediaList } = useMediaLibrary({
    organizationId,
    folder: `${product}/backgrounds`,
    skip: !enableBackgroundImageButton
  });

  if (!mediaList || mediaList.length === 0 || !enableBackgroundImageButton) {
    return null;
  }

  if (currentBackgroundImage) {
    return (
      <ColumnButton
        type="button"
        size="sm"
        onClick={() => onChange(null)}
        buttonText="Remove background image"
      />
    );
  }

  return (
    <>
      {showBackgroundImageModal && (
        <Modal
          onClose={() => setShowBackgroundImageModal(false)}
          size="2xl"
          id="background-image-gallery"
          title="Choose image"
        >
          <MediaGrid
            mediaList={mediaList}
            onClick={media => {
              onChange(media);
              setShowBackgroundImageModal(false);
            }}
          />
        </Modal>
      )}
      <ColumnButton
        type="button"
        size="sm"
        onClick={() => setShowBackgroundImageModal(true)}
        buttonText="Background image"
        startIcon={<AddImageIcon className="w-4 h-4" />}
      />
    </>
  );
}

export default BackgroundImageButton;
